import {makeStyles} from '@material-ui/core/styles'

export default makeStyles({
  footer: {
    textAlign: 'center',
    color: '#0a043c'
  },

})
